import {createContext, useContext, useState} from "react";

const TranslationContext = createContext();

export const useTranslation = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }) => {
    const [translations, setTranslations] = useState({});
    const [locale, setLocale] = useState('en_US');

    const loadTranslations = async (locale) => {
        try {
            const response = await fetch(`/translation/${locale}`);
            const data = await response.json();
            setTranslations(data);
            setLocale(locale);
        } catch (error) {
            //console.error('Failed to load translations:', error);
        }
    };

    return (
        <TranslationContext.Provider value={{ translations, locale, loadTranslations }}>
            {children}
        </TranslationContext.Provider>
    );
};